import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd, RoutesRecognized } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { GlobalVariableService } from '../Shared/global-variable.service';
import { ScrambleUnscramblestring } from '../Shared/scramble';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private _authenticationService: AuthenticationService,
    private _globalVariableService: GlobalVariableService,
    private ScrambleString: ScrambleUnscramblestring) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    // if(this._globalVariableService.IsLogged()){
    //   return true;
    // }    //   else{
    //     this._globalVariableService.logout("", "terminated");
    //     this.router.navigate(['/login']);
    //   }


    if (+sessionStorage.tabCount > 0) {
      this._globalVariableService.logout("", "terminated");
      sessionStorage.tabCount = 0;
     // this.router.navigate(['/login']);
      sessionStorage.clear;
    } else {
      sessionStorage.tabCount = 0;
      sessionStorage.tabCount = +sessionStorage.tabCount + 1;
      window.onunload = function () {
        sessionStorage.tabCount = 0;
      };
    }




    if (this._authenticationService.isLoggedIn()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  canActivateChild() {

    let baseURL = window.location.href;
    let split = baseURL.split("/");
    let a = split[split.length - 2];
    let urlname = a;

    let regData;

    if(urlname == 'avendusdp'){
      regData = sessionStorage.getItem('A_LoginDetails') || '';
    }
    else  if(urlname == 'renaissance'){
      regData = sessionStorage.getItem('A_LoginDetails') || '';
    }
    else if(urlname == 'iifldp' || urlname == 'whiteoakdp'){
      regData = sessionStorage.getItem('LoginDetails') || '';
    }
   
    if (regData) {
      regData = JSON.parse(this.ScrambleString.ApplyInternalFilter("Unveil", regData));

      if (regData['name'] && regData['amcname'] == urlname) {
        return true;
      } else {
        this.router.navigate([urlname + '/login']);
        return false;
      }

    } else {
      this.router.navigate([urlname + '/login']);
      return false;
    }

  }

}
